import React from 'react';

interface EditProfileIconProps {
    width?: string | number;
    height?: string | number;
    fill?: string;
    className?: string;
}

const EditProfileIcon: React.FC<EditProfileIconProps> = ({ 
    width = "60", 
    height = "60", 
    fill = "none",
    className 
}) => {
    return (
        <svg 
            width={width} 
            height={height} 
            viewBox="0 0 60 60" 
            fill={fill} 
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <circle cx="30" cy="30" r="30" fill="#FDD000"/>
            <mask id="mask0_2679_4875" style={{maskType:"alpha"}} maskUnits="userSpaceOnUse" x="0" y="0" width="60" height="60">
                <circle cx="30" cy="30" r="30" fill="#FDD000"/>
            </mask>
            <g mask="url(#mask0_2679_4875)">
                <rect x="-6.5" y="11" width="35" height="13" transform="rotate(30 -6.5 11)" fill="#15C9E2" fillOpacity="0.1"/>
                <rect x="52.5" y="27" width="35" height="13" transform="rotate(30 52.5 27)" fill="#AF2DFF" fillOpacity="0.2"/>
                <circle cx="12.5" cy="45.5" r="16.5" fill="#FF2164" fillOpacity="0.1"/>
                <circle cx="20.5" cy="26.5" r="9.5" fill="#AF2DFF" fillOpacity="0.1"/>
                <circle cx="46.5" cy="0.5" r="9.5" fill="#AF2DFF" fillOpacity="0.1"/>
                <rect x="51.5" y="-8" width="35" height="35" transform="rotate(30 51.5 -8)" fill="white" fillOpacity="0.4"/>
                <rect x="43.9038" y="31.9092" width="9.82441" height="9.82441" transform="rotate(30 43.9038 31.9092)" fill="white" fillOpacity="0.2"/>
                <rect x="22.9038" y="8.91016" width="9.82441" height="9.82441" transform="rotate(30 22.9038 8.91016)" fill="white" fillOpacity="0.2"/>
            </g>
            <circle cx="38.5002" cy="15.2776" r="4" transform="rotate(30 38.5002 15.2776)" fill="#15C9E2"/>
            <path d="M32.0361 18.4736L38.9643 22.4736L34.9643 29.4018L28.0361 25.4018L32.0361 18.4736Z" fill="#AF2DFF"/>
            <path d="M28.0361 25.4023L34.9643 29.4023L30.9643 36.3305L24.0361 32.3305L28.0361 25.4023Z" fill="#FF4A6B"/>
            <path d="M24.0361 32.3301L30.9643 36.3301L26.9643 43.2583L20.0361 39.2583L24.0361 32.3301Z" fill="#7E2CF5"/>
            <path d="M20.0361 39.2588L26.9643 43.2588L19.5002 48.187L20.0361 39.2588Z" fill="white"/>
            <circle cx="24" cy="48" r="1" fill="white"/>
            <circle cx="28" cy="48" r="1" fill="white"/>
            <circle cx="32" cy="48" r="1" fill="white"/>
            <circle cx="36" cy="48" r="1" fill="white"/>
        </svg>
    );
};

export default EditProfileIcon;
